const STORAGE_KEY = 'my-txt-dev-impersonate-user-id';
const POSITION_STORAGE_KEY = 'my-txt-dev-switcher-position';
const VISIBLE_STORAGE_KEY = 'my-txt-dev-switcher-visible';
/** Fired when the floating panel is shown/hidden (dev only). */
export const DEV_SWITCHER_VISIBLE_EVENT = 'my-txt-dev-switcher-visible';

export type DevSwitcherPosition = {
  x: number;
  y: number;
};

export function isDevUserSwitchEnabled(): boolean {
  return process.env.NODE_ENV !== 'production';
}

/** Panel starts visible; persists hide/show across reloads in development. */
export function isDevSwitcherVisible(): boolean {
  if (!isDevUserSwitchEnabled()) return false;
  const raw = localStorage.getItem(VISIBLE_STORAGE_KEY);
  if (raw === null) return true;
  return raw !== '0';
}

export function setDevSwitcherVisible(visible: boolean): void {
  if (!isDevUserSwitchEnabled()) return;
  localStorage.setItem(VISIBLE_STORAGE_KEY, visible ? '1' : '0');
  window.dispatchEvent(
    new CustomEvent(DEV_SWITCHER_VISIBLE_EVENT, { detail: visible }),
  );
}

export function getDevImpersonateUserId(): string | null {
  if (!isDevUserSwitchEnabled()) return null;
  return localStorage.getItem(STORAGE_KEY);
}

export function setDevImpersonateUserId(userId: string | null): void {
  if (!isDevUserSwitchEnabled()) return;
  if (userId) {
    localStorage.setItem(STORAGE_KEY, userId);
  } else {
    localStorage.removeItem(STORAGE_KEY);
  }
}

export function getDevSwitcherPosition(): DevSwitcherPosition | null {
  if (!isDevUserSwitchEnabled()) return null;
  try {
    const raw = localStorage.getItem(POSITION_STORAGE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw) as DevSwitcherPosition;
    if (typeof parsed.x === 'number' && typeof parsed.y === 'number') {
      return parsed;
    }
  } catch {
    // ignore invalid saved position
  }
  return null;
}

export function setDevSwitcherPosition(position: DevSwitcherPosition): void {
  if (!isDevUserSwitchEnabled()) return;
  localStorage.setItem(POSITION_STORAGE_KEY, JSON.stringify(position));
}

export function getDefaultDevSwitcherPosition(
  panelWidth = 360,
): DevSwitcherPosition {
  if (typeof window === 'undefined') {
    return { x: 12, y: 12 };
  }
  return {
    x: Math.max(12, window.innerWidth - panelWidth - 12),
    y: 12,
  };
}

export function clampDevSwitcherPosition(
  x: number,
  y: number,
  panelWidth = 360,
  panelHeight = 220,
): DevSwitcherPosition {
  if (typeof window === 'undefined') {
    return { x, y };
  }
  const maxX = Math.max(8, window.innerWidth - panelWidth - 8);
  const maxY = Math.max(8, window.innerHeight - panelHeight - 8);
  return {
    x: Math.min(Math.max(8, x), maxX),
    y: Math.min(Math.max(8, y), maxY),
  };
}
